import { render, staticRenderFns } from "./DamageLossesList.vue?vue&type=template&id=0076d293"
import script from "../../controllers/damage-losses/damage-losses-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/damage-losses/damage-losses-list.js?vue&type=script&lang=js&external"
import style0 from "./DamageLossesList.vue?vue&type=style&index=0&id=0076d293&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports